/* eslint-disable no-unused-vars */
export interface IResolve<T> {
  Code: number;
  Data: T;
  Message: string;
}
export interface ICoordinates {
  Lat: number;
  Lng: number;
}
export interface IStartEndTimes {
  Start: string;
  End: string;
}
export interface IPaginationParams {
  PageIndex: number;
  PageSize: number;
};
export interface IPaginationData {
  Count: number
  HasNextPage: boolean
  HasPreviousPage: boolean
  PageIndex: number
  TotalPages: number
}
export enum DriverStatus {
  InvitationFailed=1, // 邀请失败
  HasInvited=2, // 已邀请
  HasJoined=3, // 已加入
  ToAudit=4, // 待审核
  IsBinding=5, // 已绑定
  HasBeenDiscontinued=6, // 已停用
}

export type StringifyProperties<T> = {
  [K in keyof T]: string;
};

/** 取货清点 */
export enum PickUpInventory
{
  MerchType,
  Yes,
  No
}
/** 取货签名 */
export enum PickUpSignature
{
  MerchType,
  Customer,
  Driver,
  CustomerAndDriver,
  No,
  CustomerOrDriver,
}
/** 送货清点 */
export enum DeliveryInventory
{
  MerchType,
  Yes,
  No,
}
/** 送货签名 */
export enum DeliverySignature
{
  MerchType,
  Customer,
  Driver,
  CustomerAndDriver,
  No,
  CustomerOrDriver,
}
/** 上传落货照 */
export enum DeliveryPhoto
{
  MerchType,
  Yes,
  No,
}

export const Gender = {
  '-1': '*',
  1: '男',
  2: '女',
};
export type GenderEnum = keyof typeof Gender
